export const IS_FIRST_VISIT_AFTER_REGISTRATION_KEY = 'is_first_visit_after_registration';

export function setFirstVisitRegistration(isVisitRegistration: boolean): void {
  if (typeof window !== 'undefined') {
    try {
      localStorage.setItem(IS_FIRST_VISIT_AFTER_REGISTRATION_KEY, isVisitRegistration.toString());
    } catch {
      // Ignore storage errors
    }
  };
}

export function getFirstVisitRegistration(): boolean | undefined {
  const defaultValue = undefined;
  if (typeof window !== 'undefined') {
    try {
      const value = localStorage.getItem(IS_FIRST_VISIT_AFTER_REGISTRATION_KEY);
      return value === 'true';
    } catch {
      return defaultValue;
    }
  }
  return defaultValue;
}
